import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { CmsConfig, provideDefaultConfig, UrlModule } from '@spartacus/core'
import { SpinnerModule } from '@spartacus/storefront'
import { UserPermissionsGuard } from '../../../../../guards/user-permissions.guard'
import { SharedModule } from '../../../../shared/shared.module'
import { ShipmentCreditClaimsDetailComponent } from './shipment-credit-claims-detail.component'

@NgModule({
  declarations: [ShipmentCreditClaimsDetailComponent],
  imports: [RouterModule, UrlModule, SharedModule, SpinnerModule],
  providers: [
    provideDefaultConfig({
      cmsComponents: {
        ShipmentCreditClaimDetailComponent: {
          component: ShipmentCreditClaimsDetailComponent,
          guards: [UserPermissionsGuard]
        }
      }
    } as CmsConfig)
  ]
})
export class ShipmentCreditClaimsDetailModule {}
